<template>
  <div>
    <div class="level">

      <div class="level-left">
        <div class="level-item">
          <h2>{{ title }}</h2>
        </div>
      </div>

      <div class="level-right"
           v-if="reports.length">
        <div class="level-item">
          <b-select v-model="showingReportUUID"
                    @input="identifyReport">
            <option v-for="rpt in reports"
                    :key="rpt.uuid"
                    :value="rpt.uuid">
              {{ rpt.date }}
            </option>
          </b-select>
        </div>
      </div>

    </div>
    <div v-if="!reports.length">
      <p>(there aren&apos;t any yet)</p>
    </div>
    <br />

    <div v-if="showingReport">
      <p class="has-text-weight-bold">{{ showingReport.date }}</p>
      <div class="container">
        <embed type="application/pdf"
               :src="`/api/mgmt-message/${showingReport.uuid}/rawbytes`"
               style="width: 100%; height: 50rem;"
               />
      </div>
    </div>

  </div>
</template>

<script>
export default {
    name: 'ReportList',
    props: {
        title: String,
        reportType: Number,
    },
    data() {
        return {
            reports: [],
            showingReport: null,
            showingReportUUID: null,
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            }

            // we did it!
            this.inited = true
        },

        identifyReport(uuid) {
            for (let rpt of this.reports) {
                if (rpt.uuid == uuid) {
                    this.showingReport = rpt
                    break
                }
            }
        },

        fetchData() {
            let params = {
                // we only want reports of a certain type
                filters: JSON.stringify([
                    {field: 'type_code', op: 'eq', value: this.reportType},
                ]),
                sort: 'date|desc',
            }
            this.$http.get('/api/mgmt-messages', {params: params}).then(response => {
                // console.log(response.data)
                this.reports = response.data.data
                if (this.reports.length) {
                    this.showingReportUUID = this.reports[0].uuid
                    this.identifyReport(this.showingReportUUID)
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to load data:  (unknown error)",
                    type: 'is-danger',
                    duration: 4000, // 4 seconds
                })
            })
        },
    },

}
</script>
